export default {
    SAVE: 'Speichern',
    CANCEL: 'Abbrechen',
};
